var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotifyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.25 0C14.4382 0 0 14.4382 0 32.25C0 50.0618 14.4382 64.5 32.25 64.5C50.0618 64.5 64.5 50.0618 64.5 32.25C64.5 14.4404 50.0618 0.00220061 32.25 0ZM47.0403 46.5122C46.4616 47.4628 45.2226 47.7599 44.2764 47.1812C36.704 42.5533 27.171 41.508 15.9456 44.0717C14.8629 44.3204 13.7846 43.6426 13.5382 42.5599C13.2895 41.4772 13.9651 40.3989 15.05 40.1524C27.3338 37.3466 37.8726 38.5548 46.3735 43.7482C47.3198 44.3314 47.6213 45.5659 47.0403 46.5122ZM50.986 37.7339C50.2576 38.9179 48.7084 39.2876 47.5267 38.5614C38.8606 33.2337 25.6438 31.691 15.3911 34.8027C14.0619 35.2054 12.6579 34.455 12.253 33.128C11.8525 31.7989 12.6029 30.3971 13.9299 29.9922C25.6416 26.4382 40.203 28.1591 50.1564 34.2768C51.3403 35.0052 51.7144 36.5522 50.986 37.7339ZM51.3249 28.5882C40.9292 22.4155 23.782 21.8477 13.8573 24.8581C12.264 25.3423 10.5784 24.4422 10.0964 22.849C9.61448 21.2557 10.5123 19.5701 12.1078 19.0859C23.5004 15.6288 42.4366 16.2955 54.4036 23.3991C55.8362 24.2508 56.3071 26.1015 55.4577 27.5319C54.6104 28.9667 52.7553 29.4398 51.3249 28.5882Z",
    fill: "#8AD9F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.5,
    height: 64.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyicon);
export default __webpack_public_path__ + "static/media/spotifyicon.39fe2db784983a18f086f5b5730cae02.svg";
export { ForwardRef as ReactComponent };